import { POPUP_TYPES } from '@/features/Popup/constants';
import { addToQueue, removeFromQueueSpecific } from '@/store/actions';
import { useStore } from '@/store/useStore';

/** Queue sentinel only — CPE (RG UM) renders the RC UI. */
const REALITY_CHECK_QUEUE_POPUP = () => {};

export const queueRealityCheckAutoplayGuard = (): void => {
  const queue = useStore.getState().state ?? [];
  if (queue.some((item) => item?.type === POPUP_TYPES.REALITY_CHECK)) {
    return;
  }

  addToQueue({
    type: POPUP_TYPES.REALITY_CHECK,
    popup: REALITY_CHECK_QUEUE_POPUP,
  });
};

export const dequeueRealityCheckAutoplayGuard = (): void => {
  removeFromQueueSpecific({ type: POPUP_TYPES.REALITY_CHECK });
};
